import { memo } from 'react';
const ProductPlaceholderWithoutText = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 61 61"
        >
            <g transform="translate(-1379 -3020)">
                <rect
                    className="a"
                    fill="#fafafa"
                    width="61"
                    height="61"
                    transform="translate(1379 3020)"
                />
                <g transform="translate(1393 3034)">
                    <path
                        className="b"
                        fill="none"
                        stroke="#707070"
                        strokeWidth="0.4px"
                        d="M0,0H45.686"
                        transform="translate(0 32.304) rotate(-45)"
                    />
                    <path
                        className="b"
                        fill="none"
                        stroke="#707070"
                        strokeWidth="0.4px"
                        d="M0,0H45.685"
                        transform="translate(32.304 32.304) rotate(-135)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default memo(ProductPlaceholderWithoutText);
